import { type SanitySimplePortableText } from '@data/sanity/queries/types/content'

import Accordion from '@components/accordion'
import SimplePortableText from '@components/simple-portable-text'

interface ProductDescriptionProps {
  title?: string
  description?: SanitySimplePortableText
  isOpenByDefault?: boolean
}

const ProductDescription = ({
  title,
  description,
  isOpenByDefault,
}: ProductDescriptionProps) => {
  if (!description) {
    return null
  }

  return (
    <Accordion
      id="product-description"
      title={title}
      isOpenByDefault={isOpenByDefault}
    >
      <SimplePortableText content={description} className="rc" />
    </Accordion>
  )
}

export default ProductDescription
